module.exports = __webpack_public_path__ + "img/logotitulo.430d5ebe.png";